// extracted by mini-css-extract-plugin
module.exports = {"heading":"basic-page-heading-module--heading--3Ot7n"};